import React from 'react';
import { ClassNames } from '@emotion/core';

import {
  ModalDialogRoot,
  ModalDialogHeader,
  ModalDialogBody,
  ModalDialogFooter,
  Text,
} from '@zapier/design-system';

import AsyncButton from 'app/developer-v3/components/AsyncButton';
import Link from 'app/common/components/Link';
import { PLATFORM_MARKETING_BASE_URL } from 'app/developer-v3/constants';
import { usePoweredByZapierTos } from 'app/developer-v3/hooks';

type Props = {
  onClose: () => void;
};

export default function PoweredByZapierTos({ onClose }: Props) {
  const { isLoading, renew, shouldRenew } = usePoweredByZapierTos();

  return (
    <ClassNames>
      {({ css }) => (
        <ModalDialogRoot
          dialogClassName={css({
            maxWidth: '550px',
          })}
          isOpen={shouldRenew}
          onOpenChange={open => {
            if (!open) onClose();
          }}
        >
          <ModalDialogHeader>
            Powered by Zapier Terms have changed
          </ModalDialogHeader>
          <ModalDialogBody>
            <Text tag="p" type="Body1">
              We recently updated the{' '}
              <Link
                href={`${PLATFORM_MARKETING_BASE_URL}/powered-by-zapier-terms`}
                target="_blank"
              >
                Powered by Zapier Terms
              </Link>
              . By continuing to use Powered by Zapier services, you agree to
              these updated terms.
            </Text>
          </ModalDialogBody>
          <ModalDialogFooter>
            <AsyncButton
              isDisabled={isLoading}
              isWorking={isLoading}
              onPress={() => renew()}
            >
              Continue
            </AsyncButton>
          </ModalDialogFooter>
        </ModalDialogRoot>
      )}
    </ClassNames>
  );
}
